module.exports = __webpack_public_path__ + "img/wuxi.e843d8e.png";